export default __webpack_public_path__ + "media/images/paylogos/color/mastercard_secure-799c9287d4244541bbc257d55f7878d1.png";